import apiClient from '@lib/apiClient';

import { SharedApiUrl } from './endpoints';
import {
    NegotiateWebsocketUrlHubs,
    NegotiateWebsocketUrlResponse,
    PromptGroups,
    RolesWithPrompts,
} from './types';

export const getNegotiatedWebsocketUrl = async (
    hub: NegotiateWebsocketUrlHubs
): Promise<NegotiateWebsocketUrlResponse> => {
    const response = await apiClient.get<NegotiateWebsocketUrlResponse>(
        SharedApiUrl.NegotiateWebsocketUrl,
        {
            params: {
                hub,
            },
        }
    );
    return response.data;
};

const lastRole = 'others';

export const getPredefinedPromptsByRole = async (): Promise<RolesWithPrompts> => {
    const response = await apiClient.get<RolesWithPrompts>(SharedApiUrl.PredefinedPromptsByRole);
    const sortedData = response.data.toSorted((a, b) => {
        if (a.role.toLowerCase() === lastRole) return 1;
        if (b.role.toLowerCase() === lastRole) return -1;
        return a.role.localeCompare(b.role);
    });
    return sortedData;
};

export const getGeneralPredefinedPrompts = async (): Promise<PromptGroups> => {
    const response = await apiClient.get<PromptGroups>(SharedApiUrl.GeneralPredefinedPrompts);
    return response.data;
};

export const downloadBlobFile = async (absolutePath: string): Promise<Blob> => {
    const response = await apiClient.post<Blob>(SharedApiUrl.DownloadBlobFile, null, {
        params: { absolutePath },
        responseType: 'blob',
    });
    return response.data;
};
